import TimeSelector from "@/components/internal_requests/KPI/TasksReport/TimeSelector";
import MinuteHourSelector from "@/components/internal_requests/KPI/TasksReport/MinuteHourSelector";
// import WeekSelector from "@/components/internal_requests/KPI/TasksReport/WeekSelector";
// import DaySelector from "@/components/internal_requests/KPI/TasksReport/DaySelector";
//import AddToWeek from "@/components/internal_requests/KPI/TasksReport/AddToWeek";

export default (thiss) => [
  {
    prop: "ID",
    label: "Solicitud",
    "min-width": 100,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Name",
    label: "Descripción",
    "min-width": 130,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  // {
  //   prop: "WeekNumber",
  //   label: "Semana",
  //   "min-width": 130,
  //   sortable: true,
  //   cellAtrrs: {
  //     editEneable: true,
  //     updatingWeekNumberValue: thiss.updatingWeekNumberValue
  //   },
  //   formatter: WeekSelector
  // },
  // {
  //   prop: "DayOfWeek",
  //   label: "Día",
  //   "min-width": 130,
  //   sortable: true,
  //   cellAtrrs: {
  //     Value: "h",
  //     updatingDayOfWeekValue: thiss.updatingDayOfWeekValue
  //   },
  //   formatter: DaySelector
  // },
  {
    prop: "TimeOntask",
    label: "Tiempo Estimado",
    "min-width": 130,
    sortable: true,
    cellAtrrs: {
      editEneable: true,
      updatingTimeOntaskValue: thiss.updatingTimeOntaskValue
    },
    formatter: TimeSelector
  },
  {
    prop: "TypeOfTime",
    label: "Minutos/Horas",
    "min-width": 130,
    sortable: true,
    cellAtrrs: {
      Value: "h",
      updatingTypeOfTimeValue: thiss.updatingTypeOfTimeValue
    },
    formatter: MinuteHourSelector
  }
  // {
  //   prop: "",
  //   label: "Agregar a la Semana",
  //   "min-width": 130,
  //   sortable: true,
  //   cellAtrrs: {
  //     updatingWeekValue: thiss.updatingWeekValue
  //   },
  //   formatter: AddToWeek
  // }
];

export const MockData = [
  {
    Id: 1,
    description: "Solicitud de vacaciones",
    estimatedTime: 120,
    minuteHours: "m"
  },
  {
    Id: 2,
    description: "Solicitud de permisos",
    estimatedTime: 60,
    minuteHours: "m"
  },
  {
    Id: 3,
    description: "Solicitud de permisos",
    estimatedTime: 30,
    minuteHours: "m"
  },
  {
    Id: 4,
    description: "Solicitud de permisos",
    estimatedTime: 90,
    minuteHours: "m"
  },
  {
    Id: 5,
    description: "Solicitud de permisos",
    estimatedTime: 45,
    minuteHours: "m"
  },
  {
    Id: 6,
    description: "Solicitud de permisos",
    estimatedTime: 15,
    minuteHours: "h"
  },
  {
    Id: 7,
    description: "Solicitud de permisos",
    estimatedTime: 75,
    minuteHours: "m"
  },
  {
    Id: 8,
    description: "Solicitud de permisos",
    estimatedTime: 120,
    minuteHours: "m"
  },
  {
    Id: 9,
    description: "Solicitud de permisos",
    estimatedTime: 60,
    minuteHours: "m"
  },
  {
    Id: 10,
    description: "Solicitud de permisos",
    estimatedTime: 30,
    minuteHours: "m"
  },
  {
    Id: 11,
    description: "Solicitud de permisos",
    estimatedTime: 90,
    minuteHours: "m"
  },
  {
    Id: 12,
    description: "Solicitud de permisos",
    estimatedTime: 45,
    minuteHours: "m"
  },
  {
    Id: 13,
    description: "Solicitud de permisos",
    estimatedTime: 15,
    minuteHours: "m"
  },
  {
    Id: 14,
    description: "Solicitud de permisos",
    estimatedTime: 75,
    minuteHours: "m"
  },
  {
    Id: 15,
    description: "Solicitud de permisos",
    estimatedTime: 120,
    minuteHours: "m"
  },
  {
    Id: 16,
    description: "Solicitud de permisos",
    estimatedTime: 60,
    minuteHours: "m"
  },
  {
    Id: 17,
    description: "Solicitud de permisos",
    estimatedTime: 30,
    minuteHours: "m"
  },
  {
    Id: 18,
    description: "Solicitud de permisos",
    estimatedTime: 90,
    minuteHours: "m"
  },
  {
    Id: 19,
    description: "Solicitud de permisos",
    estimatedTime: 45,
    minuteHours: "m"
  },
  {
    Id: 20,
    description: "Solicitud de permisos",
    estimatedTime: 15,
    minuteHours: "m"
  },
  {
    Id: 21,
    description: "Solicitud de permisos",
    estimatedTime: 75,
    minuteHours: "m"
  },
  {
    Id: 22,
    description: "Solicitud de permisos",
    estimatedTime: 120,
    minuteHours: "m"
  },
  {
    Id: 23,
    description: "Solicitud de permisos",
    estimatedTime: 60,
    minuteHours: "m"
  },
  {
    Id: 24,
    description: "Solicitud de permisos",
    estimatedTime: 30,
    minuteHours: "m"
  },
  {
    Id: 25,
    description: "Solicitud de permisos",
    estimatedTime: 90,
    minuteHours: "m"
  }
];

export const TimeAsignmentActions = [
  //   {
  //     icon: "el-icon-view",
  //     label: "Ver Detalle",
  //     command: "view_task"
  //   },
];
